import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function CanSecondLevelReviewTemplateData(loggedInUser, template) {
    const isFirstLevelReviewer = (template.reviewers || []).some(r => r.id === loggedInUser.id);
    const isSecondLevelReviewer = (template.secondLevelReviewers || []).some(r => r.id === loggedInUser.id);

    // A user who is only a first-level reviewer cannot perform second-level review.
    if (template.secondLevelReviewEnabled && isFirstLevelReviewer && !isSecondLevelReviewer) {
        return false;
    }

    if (loggedInUser.role === Role.ADMIN) {
        return true;
    }

    return (loggedInUser.role === Role.REVIEWER || loggedInUser.role === Role.MANAGER)
        && isSecondLevelReviewer;
}

export default CanSecondLevelReviewTemplateData;
